import { MarkMessagesReadRequest, NotificationsResponse } from '../../models/notification'
import { httpClient } from '../../services/http-client'

class NotificationsApi {
    getAll() {
        return httpClient
            .get('/messagecenter/messages')
            .then(res => {
                return res.data as NotificationsResponse
            })
    }

    markRead(ids: number[]) {
        return this.postRead({ message_ids: ids, mark_all_read: false })
    }

    markAllRead() {
        return this.postRead({ message_ids: [], mark_all_read: true })
    }

    private postRead(request: MarkMessagesReadRequest) {
        return httpClient
            .post('/messagecenter/messages/read', request)
            .then(res => {
                return res.data.unread_count as number
            })
    }
}

export const notificationsApi = new NotificationsApi()
